import { Stack, Tabs, Text } from '@common/ui'
import { com } from '@eidu/web'
import EntityFormInput from '../../../../components/input/EntityFormInput'
import ReferenceSetEditor from '../../../../components/input/ReferenceSetEditor'
import ReferenceSetList from '../../../../components/input/ReferenceSetList'
import DraftFieldValue from '../../../../domain/entity/DraftFieldValue'
import FieldId = com.eidu.entity.field.FieldId
import FieldType = com.eidu.entity.field.FieldType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityType = com.eidu.entity.type.EntityType
import EntityId = com.eidu.entity.EntityId

type EntityFieldInputGroupProps = {
  entityType: EntityType
  entityTypes: ReadonlyMap<EntityTypeId, EntityType>
  fields: ReadonlyMap<FieldId, DraftFieldValue>
  updateField: (value: DraftFieldValue) => void
  loading: boolean
  entityId?: EntityId
}

const EntityFieldInputGroup = ({
  entityType,
  entityTypes,
  fields,
  updateField,
  loading,
  entityId,
}: EntityFieldInputGroupProps) => {
  const allFields = entityType.fields.asJsReadonlyArrayView()
  const referenceSetFields = allFields.filter((field) => field.type === FieldType.ReferenceSet)
  const otherFields = allFields.filter((field) => field.type !== FieldType.ReferenceSet)

  return (
    <Stack gap="lg">
      {otherFields.length > 0 && (
        <Stack gap="lg">
          {otherFields.map((field) => (
            <EntityFormInput
              key={`entity-form-field-${field.id.toString()}`}
              field={field}
              fieldValue={fields.get(field.id)}
              entityTypes={entityTypes}
              updateField={updateField}
              loading={loading}
            />
          ))}
        </Stack>
      )}

      {referenceSetFields.length > 0 && (
        <Tabs
          key={referenceSetFields.map((field) => field.id.toString()).join('|')}
          defaultValue={referenceSetFields[0].id.toString()}
        >
          <Tabs.List>
            {referenceSetFields.map((field) => (
              <Tabs.Tab key={field.id.toString()} value={field.id.toString()}>
                <Text fw={600} size="sm">
                  {field.name}
                </Text>
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {referenceSetFields.map((field) => (
            <Tabs.Panel key={field.id.toString()} value={field.id.toString()} pt="md">
              {entityId ? (
                <ReferenceSetEditor entityId={entityId} field={field} editMode />
              ) : (
                <ReferenceSetList label={field.name} />
              )}
            </Tabs.Panel>
          ))}
        </Tabs>
      )}
    </Stack>
  )
}

export default EntityFieldInputGroup
